/*       */

import { gql } from '@apollo/client';

export default gql`
    query loadAvatarQuery($id: ID!) {
        result: class(id: $id) {
            id
            name
            color
            uri
            icon
            iconType
        }
    }
`;
